import path from "node:path";

export function resolveFromCwd(...parts: string[]): string {
  return path.resolve(process.cwd(), ...parts);
}

export function publicPathToFile(publicDir: string, requestPath: string): string {
  const normalized = requestPath.replace(/^\/+/, "");
  return path.resolve(process.cwd(), publicDir, normalized);
}
